import { Checkbox, Dialog, type DialogRef, Field, FieldLabel } from '@myosh/odin-components';
import { type Ref, useId, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface AiAnalysisConfirmationModalProps {
  handleSubmitConfirmation: (value: boolean) => void;
  ref?: Ref<DialogRef>;
}

const AiAnalysisConfirmationModal = ({ handleSubmitConfirmation, ref }: AiAnalysisConfirmationModalProps) => {
  const { t } = useTranslation();
  const [isAiAnalysisConfirmationCheckboxChecked, setIsAiAnalysisConfirmationCheckboxChecked] = useState(false);
  const checkboxId = useId();

  return (
    <Dialog
      data-cy="ai-analysis-confirmation-modal"
      buttons={[
        {
          name: 'submit',
          text: 'Ok',
          onClick: () => handleSubmitConfirmation(isAiAnalysisConfirmationCheckboxChecked),
        },
      ]}
      header={t(($) => $.aiAnalysis)}
      ref={ref}
    >
      <div className="flex flex-col gap-4">
        <p className="font-semibold text-lg">
          Warning: Data is sent to an external AI. Verify all AI results for accuracy.
        </p>
        <Field orientation="horizontal">
          <Checkbox
            id={checkboxId}
            data-cy="ai-analysis-confirmation-checkbox"
            name="show-ai-analysis-confirmation"
            checked={isAiAnalysisConfirmationCheckboxChecked}
            onChange={(event) => setIsAiAnalysisConfirmationCheckboxChecked(event.target.checked)}
          />
          <FieldLabel htmlFor={checkboxId} className="font-normal">
            Don’t show me again
          </FieldLabel>
        </Field>
      </div>
    </Dialog>
  );
};

export default AiAnalysisConfirmationModal;
